
/* injects from baggage-loader */

'use strict';

export default function (app) {
    app.provider('resolver', resolverProvider);

    function resolverProvider () {
        this.asyncPagePrealoading = asyncPagePrealoading;
        this.$get = function() { return this; };
    }

    
        function asyncPagePrealoading ($q) {
            "ngInject";

            const defer = $q.defer();
            // Some async stuff (request, calculations, etc.)
            return defer.promise;
        }
    

}



// WEBPACK FOOTER //
// ./src/app/core/services/resolver.provider.js